import React, { FC } from 'react'
import SidePanelFramework from '@bt-react/components/SidePanelFramework'
import { IconType } from '@bt-react/components/Icon'
import VotesView, { VotesViewProps } from '@bt-react/components/Votes/VotesView'

const VotesPanel: FC<VotesViewProps> = props => {

  return <SidePanelFramework
    icon={IconType.iconName.votes}
    title='Polls'
    dataBdd='side-panel-session-status'
    scrollable={true}
    content={
      <VotesView
          {...props}
        />
    }
  />

}

export default VotesPanel
